import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cardDeliveryStatus'
})
export class CardDeliveryStatusPipe implements PipeTransform {

  transform(value: string): string {
    if (value === '01') {
      return 'Asignación';
    } else if (value === '02') {
      return 'En Alistamiento';
    } else if (value === '03') {
      return 'En Distribución';
    } else if (value === '04') {
      return 'Entregada';
    } else if (value === '05') {
      return 'Ilocalizada';
    } else if (value === '06') {
      return 'En Custodia';
    } else if (value === '07') {
      return 'Generación';
    } else if (value === '98') {
      return 'Error de Entrega';
    } else if (value === '99') {
      return 'Inhabilitada';
    }
  }

}


